import { VERTICALS } from './vertical';

/**
 * Path prefixes that are public (no auth required).
 * Must stay in sync with App.tsx PUBLIC_ROUTE_CONFIGS legacyPaths and path segments.
 * Used to avoid redirecting to login on 401 when user is on a public page (e.g. landing, login, blog).
 */
const PUBLIC_LEGACY_PREFIXES: readonly string[] = [
  '/',
  '/login',
  '/register',
  '/signup',
  '/join-vineyard',
  '/reset-password',
  '/accept-invitation',
  '/terms',
  '/privacy',
  '/about',
  '/blog',
  '/resources',
];

/**
 * Returns true if the pathname is a public route where unauthenticated access is allowed.
 * Used by the API layer to avoid redirecting to login on 401 when the user is on a public page.
 *
 * Covers:
 * - Legacy paths: /, /login, /register, /about, /blog, /resources, etc.
 * - All vertical roots and subpaths: /vineyard, /orchard, /greenhouse, /greenhouse/about, /orchard/login, etc.
 *
 * Security note: This is UX-only. It does not grant access to any resource. Protected API
 * endpoints are enforced by the backend; we only decide whether to redirect to login on 401.
 */
export function isPublicPath(pathname: string): boolean {
  const path = pathname.replace(/\/$/, '') || '/';
  for (const prefix of PUBLIC_LEGACY_PREFIXES) {
    if (prefix === '/') {
      if (path === '/') return true;
      continue;
    }
    if (path === prefix || path.startsWith(prefix + '/')) return true;
  }
  const firstSegment = path.split('/').filter(Boolean)[0] as string | undefined;
  if (firstSegment && (VERTICALS as readonly string[]).includes(firstSegment)) {
    return true;
  }
  return false;
}
